import React from 'react';
import clsx from 'clsx';

// Material UI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';

// Components
import useStyles from '../styles';

const SectionButton = ({ icon, notSelctedMessage, isSelected, children }) => {
    const { classes } = useStyles();
    const Icon = icon;

    const iconStyles = clsx(classes.iconContainer, {
        [classes.iconSelected]: isSelected,
        [classes.iconNotSelected]: !isSelected,
        [classes.iconWarning]: (icon === WarningIcon)
    });

    return (
        <Grid container alignItems='center' spacing={2} size={12}> 
            <Grid size={2}>
                <div className={iconStyles}>
                    <Icon />
                </div>
            </Grid>
            <Grid size={10}>
                {
                    !isSelected
                    ? <Typography variant="overline" display="block" noWrap>
                        {notSelctedMessage}
                    </Typography>
                    : children
                }
            </Grid>
        </Grid>
    );
}

export default SectionButton;